import type { PaymentMethodFieldConfig } from "../types/new-payment.types";

const TIPO_CUENTA_AHORROS_CORRIENTE: { label: string; value: string }[] = [
  { label: "Ahorros", value: "Ahorros" },
  { label: "Corriente", value: "Corriente" },
];

const TIPO_DOCUMENTO_COP_ACH: { label: string; value: string }[] = [
  { label: "Nit", value: "NIT" },
  { label: "Cc", value: "CC" },
  { label: "Ce", value: "CE" },
  { label: "Pasaporte", value: "PASAPORTE" },
  { label: "Ppt", value: "PPT" },
];

const PIX_KEY_TYPES: { label: string; value: string }[] = [
  { label: "CPF", value: "0" },
  { label: "CNPJ", value: "1" },
  { label: "Email", value: "2" },
  { label: "Teléfono", value: "3" },
  { label: "EVP", value: "4" },
];

const FPS_ID_TYPES: { label: string; value: string }[] = [
  { label: "Teléfono", value: "Teléfono" },
  { label: "Email", value: "Email" },
  { label: "ID FPS", value: "ID FPS" },
];

const CRYPTO_STABLECOIN_WALLET_FIELDS: PaymentMethodFieldConfig[] = [
  { id: "direccionWallet", label: "Dirección de wallet", type: "text", required: true },
];

type ConfigKey = string;

const FIELDS_BY_CURRENCY_METHOD: Record<ConfigKey, PaymentMethodFieldConfig[]> = {
  "COP|Bre-B": [{ id: "llaveBreB", label: "Llave Bre-B", type: "text", required: true }],
  "COP|Nequi": [
    {
      id: "numeroCelularNequi",
      label: "Número celular asociado a Nequi",
      type: "tel",
      required: true,
    },
  ],
  "COP|ACH": [
    { id: "bancoAch", label: "Banco", type: "text", required: true },
    {
      id: "tipoCuenta",
      label: "Tipo de cuenta",
      type: "select",
      options: TIPO_CUENTA_AHORROS_CORRIENTE,
      required: true,
    },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    {
      id: "tipoDocumento",
      label: "Tipo de documento",
      type: "select",
      options: TIPO_DOCUMENTO_COP_ACH,
      required: true,
    },
    { id: "numeroDocumento", label: "Número de documento", type: "text", required: true },
  ],
  "COP|Bancolombia": [
    { id: "tipoCuenta", label: "Tipo de cuenta", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "numeroDocumento", label: "Número de documento", type: "text", required: true },
  ],
  "BRL|Pix": [
    {
      id: "pix_type",
      label: "Tipo de llave Pix",
      type: "select",
      options: PIX_KEY_TYPES,
      required: true,
    },
    { id: "pix_key", label: "Llave Pix", type: "text", required: true },
  ],
  "MXN|SPEI": [
    { id: "clabe", label: "CLABE (18 dígitos)", type: "text", placeholder: "18 dígitos", required: true },
  ],
  "CLP|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "tipoCuenta", label: "Tipo de cuenta", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "rut", label: "RUT", type: "text", required: true },
    { id: "email", label: "Email", type: "email", required: true },
  ],
  "CLP|Cuenta RUT": [{ id: "rut", label: "RUT", type: "text", required: true }],
  "PEN|Transferencia bancaria interbancaria (CCI)": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCci", label: "Número CCI", type: "text", required: true },
    { id: "documentoIdentidad", label: "Documento de identidad", type: "text", required: true },
  ],
  "PEN|Yape": [
    {
      id: "numeroCelularYape",
      label: "Número celular asociado a Yape",
      type: "tel",
      required: true,
    },
  ],
  "PEN|Plin": [
    {
      id: "numeroCelularPlin",
      label: "Número celular asociado a Plin",
      type: "tel",
      required: true,
    },
  ],
  "PYG|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "documentoIdentidad", label: "Documento de identidad", type: "text", required: true },
  ],
  "UYU|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "documentoIdentidad", label: "Documento de identidad", type: "text", required: true },
  ],
  "USD|ACH": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "routingNumber", label: "Routing number", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "tipoCuenta", label: "Tipo de cuenta", type: "text", required: true },
  ],
  "USD|Wire Transfer": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "swiftBic", label: "SWIFT / BIC", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "direccionBanco", label: "Dirección del banco", type: "text", required: true },
  ],
  "USD|Zelle": [
    {
      id: "emailOTelefonoZelle",
      label: "Email o número telefónico asociado",
      type: "text",
      required: true,
    },
  ],
  "USD|Transferencia interna bancaria": [
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
  ],
  "EUR|SEPA": [
    { id: "iban", label: "IBAN", type: "text", required: true },
    { id: "banco", label: "Banco", type: "text", required: true },
  ],
  "EUR|SEPA Instant": [{ id: "iban", label: "IBAN", type: "text", required: true }],
  "HKD|FPS (Faster Payment System)": [
    {
      id: "tipoIdentificadorFps",
      label: "Tipo de identificador",
      type: "select",
      options: FPS_ID_TYPES,
      required: true,
    },
    { id: "identificadorFps", label: "Identificador FPS", type: "text", required: true },
  ],
  "HKD|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
  ],
  "HKD|CHATS": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "codigoChats", label: "Código CHATS", type: "text", required: true },
  ],
  "CNY|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
  ],
  "CNY|Alipay": [{ id: "idAlipay", label: "ID Alipay", type: "text", required: true }],
  "CNY|WeChat Pay": [{ id: "idWechat", label: "ID WeChat", type: "text", required: true }],
  "CRC|SINPE": [
    { id: "numeroCuentaIban", label: "Número de cuenta IBAN", type: "text", required: true },
    { id: "banco", label: "Banco", type: "text", required: true },
  ],
  "CRC|SINPE Móvil": [{ id: "numeroCelular", label: "Número celular", type: "tel", required: true }],
  "CRC|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuentaIban", label: "Número de cuenta IBAN", type: "text", required: true },
  ],
  "ARS|CBU": [{ id: "cbu", label: "CBU", type: "text", required: true }],
  "ARS|CVU": [{ id: "cvu", label: "CVU", type: "text", required: true }],
  "GTQ|Transferencia bancaria local": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
  ],
  "GTQ|ACH Guatemala": [
    { id: "banco", label: "Banco", type: "text", required: true },
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
    { id: "documentoIdentidad", label: "Documento de identidad", type: "text", required: true },
  ],
  "GTQ|Transferencias internas bancarias": [
    { id: "numeroCuenta", label: "Número de cuenta", type: "text", required: true },
  ],
  "USDT|TRC20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDT|BEP20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDT|Polygon": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDT|Solana": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDT|ERC20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDT|BINANCE": [
    {
      id: "binancePayUid",
      label: "UID",
      type: "text",
      required: false,
      digitsOnly: true,
    },
    {
      id: "binancePayEmail",
      label: "Email",
      type: "email",
      required: false,
    },
  ],
  "USDC|TRC20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDC|BEP20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDC|Polygon": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDC|Solana": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "USDC|ERC20": CRYPTO_STABLECOIN_WALLET_FIELDS,
  "BINANCE_PAY|BINANCE_PAY": [
    {
      id: "binancePayUid",
      label: "UID",
      type: "text",
      required: false,
      digitsOnly: true,
    },
    {
      id: "binancePayEmail",
      label: "Email",
      type: "email",
      required: false,
    },
  ],
};

export function getPaymentMethodFields(currency: string, method: string): PaymentMethodFieldConfig[] {
  if (!currency?.trim() || !method?.trim()) return [];
  const key: ConfigKey = `${currency}|${method}`;
  return FIELDS_BY_CURRENCY_METHOD[key] ?? [];
}

export function isBinanceUidEmailExclusivePair(currency: string, method: string): boolean {
  const c = currency.trim();
  const m = method.trim();
  return (c === "USDT" && m === "BINANCE") || (c === "BINANCE_PAY" && m === "BINANCE_PAY");
}
